import { Tag } from 'antd'
import styled, { css } from 'styled-components'

const StyledMenuCurationTaskTag = styled(Tag)`
  margin-top: 0.5rem;

  ${props =>
    props.isError &&
    css`
      border-color: #f50;
      color: #fff;
      background-color: #f50;
    `};

  ${props =>
    props.isWarning &&
    css`
      border-color: #faad14;
      color: #fff;
      background-color: #faad14;
    `};
`

export default StyledMenuCurationTaskTag
